import type { AppLocale } from '../messages';

/**
 * Строки участка «meetings» — встречи по ссылке (заказ владельца 2026-10-12). Здесь только то,
 * что нужно списку чатов; тексты самого экрана и входа — в `meetings/meetingStrings.ts`, вне
 * основного бандла веба.
 * Ключ добавляется во все четыре словаря — `en` задаёт набор, остальные проверяются типом.
 */
const en = {
  meetingsTitle: 'Meetings',
  meetingsOpenA11y: 'Meetings by link',
} as const satisfies Record<string, string>;

export type MeetingsMessageKey = keyof typeof en;

export const meetingsMessages: Record<AppLocale, Record<MeetingsMessageKey, string>> = {
  en,
  ru: {
    meetingsTitle: 'Встречи',
    meetingsOpenA11y: 'Встречи по ссылке',
  },
  sr: {
    meetingsTitle: 'Sastanci',
    meetingsOpenA11y: 'Sastanci preko linka',
  },
  fr: {
    meetingsTitle: 'Réunions',
    meetingsOpenA11y: 'Réunions par lien',
  },
};
